module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _vm._v(" "), _c('open-on-site', {
    staticClass: "disabled",
    attrs: {
      "source-route": '/'
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("pamphlets/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Pamphlet has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ba5b8ab","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/pamphlets/Edit.vue
// module id = 933
// module chunks = 0